import { render } from "./Agradecimento.vue?vue&type=template&id=7fd0944d&scoped=true"
import script from "./Agradecimento.vue?vue&type=script&lang=js"
export * from "./Agradecimento.vue?vue&type=script&lang=js"

import "./Agradecimento.vue?vue&type=style&index=0&id=7fd0944d&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd0944d"]])

export default __exports__